import { createAsyncThunk } from '@reduxjs/toolkit';
import { getDashboardMetricsRequest } from './dashboardApi';
import { extractApiError } from '../../utils/errors';

/**
 * Fetches the dashboard for the filters currently held in the store.
 *
 * Sentinel values are dropped rather than forwarded, same as pickups: the
 * backend treats a missing param and `'all'` alike, and leaving them out keeps
 * the request readable. It also means adding a filter to the screen is adding
 * it to `filters` — the clause is already written on the other side.
 */
export const fetchDashboard = createAsyncThunk(
  'dashboard/fetchDashboard',
  async (_, { getState, rejectWithValue }) => {
    try {
      const { start_date, end_date, company, admin_id: adminId } = getState().dashboard.filters;

      const params = { start_date, end_date };
      if (company && company !== 'all') params.company = company;
      // Staff only: for anybody else the backend forces its own admin and
      // ignores whatever arrives here.
      if (adminId && adminId !== 'all') params.admin_id = adminId;

      const response = await getDashboardMetricsRequest(params);
      return response.data;
    } catch (error) {
      console.error('Error fetching dashboard:', error);
      return rejectWithValue(extractApiError(error, 'No se pudieron obtener las métricas'));
    }
  }
);
